<template>
  <div class="page-wrapper storybook-cnc-radio-button">
    <StorybookTemplate title="CncRadioButton" pathComponent="/shared/elements/global/v1/CncRadioButton.vue" :pathFigma="pathFigma" :desc="desc" :propList="propList" :form.sync="form">
      <el-radio-group v-model="form.selected">
        <CncRadioButton v-bind="form">{{ form.name }}</CncRadioButton>
      </el-radio-group>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      pathFigma: 'https://www.figma.com/file/QGmzH850ARJRAeL8BuBAer/%5BWEB%5D-Shared-Components?type=design&node-id=3433%3A23249&mode=design&t=K4BoXeFmbltGwIwI-1',
      desc: 'วิธีการใช้ CncRadioButton ใน form สามารถใช้ <CncRadioButton/> แทน <el-radio/> ได้เลย จะเปรียบเสมือนตัว Ui ของ el-radio แต่จะพิเศษจากตัวเดิมตรงที่สามารถ cuttom icon ได้ ส่วน error การ validate from สามารถ ใส่ได้ที่ prop ของ error message หรือ จะใช้งานแบบเดิม (rules form) ก็ได้',
      propList: [
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'medium',
          option: [
            { label: 'medium', name: 'Medium' },
            { label: 'small', name: 'Small' }
          ]
        },
        {
          name: 'rightIcon',
          type: 'object',
          param: 'rightIcon',
          objectKey: [
            { key: 'name', type: 'input', value: 'info' },
            { key: 'type', value: 'svg', type: 'select', option: ['svg', 'icon'] }
          ]
        },
        { name: 'disabled', type: 'boolean', param: 'disabled' },
        { name: 'isReadOnly', type: 'boolean', param: 'isReadOnly' },
        { name: 'isError', type: 'boolean', param: 'isError' }
      ],
      form: {
        value: true,
        rightIcon: { type: 'icon', name: 'info' },
        size: 'medium',
        disabled: false,
        isReadOnly: false,
        isError: false,
        selected: 'Choice 1',
        choices: [
          { id: 1, label: 'Choice 1', name: 'Choice 1', desc: 'Description for Choice 1' }
        ]
      }
    }
  }
}
</script>
